// extracted by mini-css-extract-plugin
export default {"icon":"DuotoneIcon_icon__ZH0Vp"};